import { useState } from 'react';

export type Filters = { type?: string; scope?: string; tag?: string };

export default function FilterBar({ onChange }: { onChange: (f:Filters)=>void }) {
  const [filters, set] = useState<Filters>({});

  function toggle(key: keyof Filters, value: string) {
    const next = filters[key] === value ? { ...filters, [key]: undefined } : { ...filters, [key]: value };
    set(next); onChange(next);
  }

  return (
    <div className="flex flex-wrap gap-2 pb-3 border-b border-neutral-200 dark:border-neutral-700">
      {['plugin','component','template'].map(t => (
        <button key={t} onClick={()=>toggle('type',t)}
          className={`pill ${filters.type===t && 'pill-active'}`}>{t}</button>
      ))}
      {['core','pro','client'].map(s => (
        <button key={s} onClick={()=>toggle('scope',s)}
          className={`pill ${filters.scope===s && 'pill-active'}`}>{s}</button>
      ))}
      {/* tag pills render only when active filter not set */}
      {filters.tag && (
        <button onClick={()=>toggle('tag',filters.tag!)} className="pill pill-active">{filters.tag}</button>
      )}
    </div>
  );
}
